import { Component, Inject, OnInit } from '@angular/core';
import { ThemeService } from 'rev-portal/branding/Theme.Service';
import { SignalRHubsConnection } from 'rev-shared/push/SignalRHubsConnection';
import { SignalRHubsConnectionToken } from 'rev-shared/push/SignalRHubsConnectionToken';
import { decodeQueryString } from 'rev-shared/util/Util.Service';

import styles from './EmbedWebcast.module.less';

@Component({
	selector: 'app',
	templateUrl: './App.Component.html',
	standalone: false
})
export class AppComponent implements OnInit {

	constructor(
		@Inject(SignalRHubsConnectionToken)
		private readonly SignalRHubsConnection: SignalRHubsConnection,
		public readonly ThemeService: ThemeService
	) {}

	public ngOnInit(): void {

		document.body.classList.add(styles.body);

		this.SignalRHubsConnection.start()
			.catch(e => console.error('Error Starting SignalR: ', e));
	}
}
